import { styled } from "solid-styled-components";

export const StyledSearchInput = styled.input`
    all: unset;
    width: 100%;
    &:hover {
        cursor: text;
    }
`;
